import { useTranslation } from '@input-web/configs/locale/locale.config';
import { Outlet } from '@tanstack/react-router';
import Typography from '@ui/components/atoms/typography/typography.atom';
import SuspenseLoading from '@ui/components/molecules/suspense-loading/suspense-loading.molecule';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import StandardDetailTab from '../../components/detail-tab/standard-detail-tab.component';
import useStandardDetailLayoutViewModel from './standard-detail-layout.view-model';

export default function StandardDetailLayoutView() {
  // #region Dependencies
  const { t } = useTranslation();
  // #endregion

  // #region View Model
  const { scoringStandardDetail, tab } = useStandardDetailLayoutViewModel();
  // #endregion

  // #region Content
  const additionalDescription = useMemo(
    () => (
      <Typography.BodyOne className="text-right">
        <Trans
          components={[<span className="font-bold" />]}
          i18nKey="standard.detail-layout.tab.additional-description"
          t={t}
          values={{
            divisionName:
              scoringStandardDetail.data?.bunriName ??
              scoringStandardDetail.data?.facultyName ??
              t('symbol.none-dash'),
            partNumber: scoringStandardDetail.data?.partNumber ?? t('symbol.none-dash'),
            partYear: scoringStandardDetail.data?.partYear ?? t('symbol.none-dash'),
            subjectName: scoringStandardDetail.data?.subjectName ?? t('symbol.none-dash'),
            universityName: scoringStandardDetail.data?.universityName ?? t('symbol.none-dash'),
          }}
        />
      </Typography.BodyOne>
    ),
    [
      scoringStandardDetail.data?.bunriName,
      scoringStandardDetail.data?.facultyName,
      scoringStandardDetail.data?.partNumber,
      scoringStandardDetail.data?.partYear,
      scoringStandardDetail.data?.subjectName,
      scoringStandardDetail.data?.universityName,
      t,
    ],
  );
  // #endregion

  return (
    <section className="px-7 space-y-2.5">
      <StandardDetailTab
        className="grid grid-cols-[repeat(3,minmax(80px,1fr))]"
        items={tab.items}
      />
      <div className="flex items-center justify-between gap-6">
        <Typography.HeadingFive className="font-normal">{tab.description}</Typography.HeadingFive>
        {additionalDescription}
      </div>
      <section className="px-7 space-y-2.5">
        <SuspenseLoading>
          <Outlet />
        </SuspenseLoading>
      </section>
    </section>
  );
}
